module.exports = [{"Key":"operation_title","Value":{"Korean":"기본 조작","English":"Basic Manipulation"}},{"Key":"operation_text","Value":{"Korean":"엔닷캐드 사용을 위해 기본적인 조작 방법과\r\n화면 제어 방법을 알아봅시다.","English":"Let's find out how to oprate and control the screen for using NdotCAD."}},{"Key":"operation_img","Value":{"Korean":"/static/tutorial/functions/screen_control/기본조작.png","English":"/static/tutorial/functions/screen_control/기본조작_en.png"}}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/language/operation.json
// module id = LuRp
// module chunks = 1